import React, { useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import Loading from './Loading';

const MessageList = ({ messages, loading }) => {
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, loading]);

  const handleCopyMessage = async (content) => {
    try {
      await navigator.clipboard.writeText(content);
    } catch (err) {
      console.error('复制失败:', err);
    }
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('zh-CN', {
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="message-list">
      {messages.length === 0 && (
        <div className="empty-state">
          <div className="empty-state-icon">💭</div>
          <h2>开始与 AI 助手对话</h2>
          <ul className="feature-list">
            <li>✨ 可以问我任何问题</li>
            <li>📚 支持学习、工作、生活等各类话题</li>
            <li>💡 支持多轮对话，我会记住上下文</li>
            <li>🔄 如果回答不准确，可以继续追问</li>
          </ul>
        </div>
      )}
      {messages.map((message, index) => (
        <div 
          key={index} 
          className={`message ${message.role === 'user' ? 'user' : 'assistant'}`}
        >
          <div className="message-timestamp">
            {formatTime(message.timestamp)}
          </div>
          <div className="message-content">
            {message.role === 'user' ? (
              message.content
            ) : (
              <>
                <ReactMarkdown>{message.content}</ReactMarkdown>
                <button 
                  className="copy-button"
                  onClick={() => handleCopyMessage(message.content)}
                  title="复制消息"
                >
                  📋
                </button>
              </>
            )}
          </div>
        </div>
      ))}
      {loading && messages.length === 0 && <Loading />}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList; 